import React, { createContext, useContext, useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { decodeJWT } from "../utils/jwt";

const initialUserState: any = {
  user: null,
};

const UserContext = createContext<any>({
  setUser: (user: any) => {},
  logout: () => {},
  user: { user: null, permission: [] },
});

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<any>(initialUserState);

  const navigate = useNavigate();

  const logout = () => {
    setUser({ user: null });
    localStorage.removeItem("token");
    localStorage.removeItem("notificationSync");
    navigate("/login");
  };

  const contextValue: any = {
    setUser,
    logout,
    user,
  };

  useEffect(() => {
    if (user?.user) {
      navigate("/home");
      localStorage.setItem("token", user.user.token);
    }
  }, [user]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setUser({ user: { ...decodeJWT(token), token } });
    }
  }, []);

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
};
